import React, { useEffect, useState } from "react";
import Dialog from "@mui/material/Dialog";
import DialogContent from "@mui/material/DialogContent";
import { fichajeTotem } from "../../services/apis";
import { FichadaDialog } from "./FichadaDialog";
import { CircularProgress, Fab, Grid, Typography } from "@mui/material";
import CachedIcon from "@mui/icons-material/Cached";
import { RelojTotem } from "../../utils/componentes-utiles/RelojTotem";
import TapAndPlayIcon from '@mui/icons-material/TapAndPlay';
import nfcicon from '../../media/tarjeta-nfc.png'
import { CerrarSesion } from "../../utils/componentes-utiles/CerrarSesion";

export const TotemFichajeNFC = ({ id }) => {
    const [nfcValue, setNfcValue] = useState(null);
    const [estado, setEstado] = useState("idle");
    const [data, setData] = useState(null);
    const [totemID, setTotemId] = useState(id);

    const obtenerFechaActual = () => {
        const now = new Date();
        const fecha = now.toLocaleDateString("es-ES", {
            day: "2-digit",
            month: "2-digit",
            year: "numeric",
        });
        const hora = now.toLocaleTimeString("es-ES", {
            hour: "2-digit",
            minute: "2-digit",
            second: "2-digit",
            hour12: false,
        });
        const [dia, mes, anio] = fecha.split("/");
        return `${anio}-${mes}-${dia} ${hora}`;
    };

    const fichar = async (value) => {
        try {
            setEstado("loading");

            const fechaActual = obtenerFechaActual();

            const response = await fichajeTotem({
                fecha: fechaActual,
                cardCode: value,
                totemCode: totemID
            });

            if (!response.success) {
                setEstado("error");
                setData(null);
                return;
            }

            setEstado("success");
            setData(response);

        } catch (error) {
            console.error("Error fichando NFC:", error);
            setEstado("error");
            setData(null);
        }
    };


    // ACTIVAR NFC
    useEffect(() => {
        let buffer = "";
        let timeout = null;

        const handleKeydown = (e) => {

            // Ignorar teclas del lector que NO son parte del código
            if (
                e.key === "Shift" ||
                e.key === "Control" ||
                e.key === "Alt" ||
                e.key === "Tab"
            ) return;

            // ENTER = Fin del código → limpiar y procesar
            if (e.key === "Enter") {

                // 🔥 SOLUCIÓN REAL → solo números, como QR
                const clean = buffer.replace(/\D/g, "");

                if (clean.length > 0) {
                    setNfcValue(clean);
                }

                buffer = "";
                return;
            }

            // Aceptar solo teclas imprimibles → evita caracteres HID invisibles
            if (e.key.length === 1) {
                buffer += e.key;
            }

            // Reset automático para evitar arrastre de caracteres
            clearTimeout(timeout);
            timeout = setTimeout(() => (buffer = ""), 800);
        };

        window.addEventListener("keydown", handleKeydown);

        return () => {
            window.removeEventListener("keydown", handleKeydown);
        };
    }, []);



    useEffect(() => {
        if (nfcValue) fichar(nfcValue);
    }, [nfcValue]);

    const resetFichaje = () => {
        setNfcValue(null);
        setEstado("idle");
        setData(null);
    };

    return (
        <Dialog
            open={true}
            fullScreen
            PaperProps={{
                sx: {
                    background: "linear-gradient(to bottom, #101010ff, #000000ff)",
                    color: "#fff",
                    pb: 3,
                },
            }}
        >

            <DialogContent>
                <Grid
                    container
                    direction="column"
                    justifyContent="start"
                    alignItems="start"
                    xs={12}
                >
                    <Grid
                        container
                        direction="row"
                        justifyContent="space-between"
                        alignItems="center"
                        xs={12}
                    >
                        <Typography variant='subtitle1'>
                            ID totem:{totemID}
                        </Typography>
                        <Grid
                            container
                            direction="row"
                            justifyContent="space-between"
                            alignItems="center"
                            xs={1}
                        >

                            <Fab
                                size="large"
                                color="primary"
                                onClick={() => window.location.reload()}
                                sx={{
                                    backgroundColor: "#1f1f1f",
                                    boxShadow: "0px 0px 10px #59CE8F4d",
                                    "&:hover": { backgroundColor: "#272727" }
                                }}
                            >
                                <CachedIcon
                                    sx={{
                                        color: "#59CE8Fff",
                                        fontSize: 35,
                                        "&:hover": { transform: "rotate(-360deg)" },
                                        transition: "transform 0.5s ease-in-out"
                                    }}
                                />
                            </Fab>


                            <CerrarSesion />
                        </Grid>
                    </Grid>

                    <Grid
                        container
                        direction="column"
                        justifyContent="center"
                        alignItems="center"
                        xs={12}
                        gap={8}
                    >

                        <h1
                            style={{
                                textAlign: "center",
                                fontSize: "33px",
                                fontWeight: "300",
                                marginBottom: "10px",
                                letterSpacing: "1px",
                            }}
                        >
                            Acerca tu tarjeta NFC <br /> al dispositivo
                        </h1>

                        {/* <div
                    style={{
                        width: 500,
                        height: 300,
                        backgroundColor: "#111",
                        borderRadius: 20,
                        border: "4px solid #59CE8Fff",
                        display: "flex",
                        justifyContent: "center",
                        alignItems: "center",
                        fontSize: "22px",
                        opacity: 0.8,
                    }}
                >
                    Esperando NFC…
                </div>
                 */}

                        <Grid
                            container
                            direction="column"
                            justifyContent="center"
                            alignItems="center"
                            xs={5} md={5.5} lg={3.5}
                            gap={2}
                            sx={{
                                minHeight: '35vh',
                                maxHeight: '35vh',
                                backgroundColor: "#111",
                                borderRadius: 4,
                                border: "4px solid #59CE8Fff",
                                fontSize: "22px",
                                opacity: 0.8,
                            }}
                        >
                            {/* <TapAndPlayIcon sx={{ fontSize: 70, opacity: 0.8, }} /> */}

                            <Grid item xs={12} sx={{ textAlign: 'center' }}>
                                <img src={nfcicon} alt="NFC Icon" style={{ maxWidth: '20%', minWidth: '20%' }} />

                            </Grid>


                            <Typography variant='h5'>
                                Acerque su tarjeta al escáner NFC
                            </Typography>
                        </Grid>

                        {/* Reloj */}
                        <div style={{ marginTop: "1em" }}>
                            <RelojTotem />
                        </div>
                    </Grid>
                </Grid>
            </DialogContent>

            {estado === "loading" && (
                <Dialog
                    open
                    fullScreen
                    PaperProps={{
                        sx: {
                            background: "#000c",
                            display: "flex",
                            justifyContent: "center",
                            alignItems: "center",
                        },
                    }}
                >
                    <CircularProgress size={120} sx={{ color: "#59CE8Fff" }} />
                </Dialog>
            )}

            {estado !== "idle" && estado !== "loading" && (
                <FichadaDialog onClose={resetFichaje} estado={estado} data={data} />
            )}
        </Dialog>
    );
};
